module.exports = __webpack_public_path__ + "img/banner_lb_2.03d142ab.png";